import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { CashLocation } from "~/providers/cash-location-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useCashLocation } from "~/hooks/use-cash-location";
import { useCashLocationManager } from "~/managers/use-cash-location-manager";

export const Route = createFileRoute("/_main/settings/_layout/cash-locations/")(
  {
    component: CashLocations,
  },
);

function CashLocations() {
  const { t } = useTranslation("common");
  const { openCashLocationDialog } = useCashLocationManager();
  const { cashLocations } = useCashLocation();
  const columns: ColumnDef<CashLocation>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: productcategory }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(productcategory.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("CashLocation.cash_locations")}
        buttonLabel={capitalize(t("CashLocation.new_cash_location"))}
        buttonAction={() => {
          openCashLocationDialog();
        }}
      />

      <DataTable
        columns={columns}
        data={cashLocations}
        onSelect={openCashLocationDialog}
      />
    </>
  );
}
